import * as React from 'react';
import { connect } from 'react-redux';

import { Link } from 'libs/router';

import Entity from 'components/entity/Entity';
import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';

import { __t, applyTranslations } from 'utils/language';
import { getDisplayDate } from 'utils/date';
import { getEntityFromCampaign } from 'utils/view';
import { isCcmModerator } from 'utils/account';

import './ccm-campaigns-table-campaign-cell.scss';

applyTranslations(require('./ccm-campaigns-table-campaign-cell.i18n.json'));

import type {
  CampaignWithSubcampaignMeta,
  Role
} from 'types';

type OwnProps = {
  campaign: CampaignWithSubcampaignMeta
};

type StateProps = {
  roles: Array<Role>
};

type Props = OwnProps & StateProps;

const MSG_KEY = 'ccm_campaigns_table_campaign_cell';

const CcmCampaignsTableCampaignCell: React.FC<Props> = ({
  campaign,
  roles
}): JSX.Element => {
  const campaignEntity = getEntityFromCampaign(campaign);
  const campaignName = campaignEntity?.displayName;
  const isModerator = isCcmModerator(roles);
  let route = `/campaigns/ccm/${campaign.id}`;

  if (isModerator) {
    route += '/participants/accepted';
  } else {
    route += '/overview';
  }

  return (
    <div className="ccm-campaigns-table-campaign-cell">
      <Entity>
        <EntityAvatar
          link={route}
          entity={campaignEntity}
          bordered
          form="square"
          size="customSize"
          customSize={{
            width: 68,
            height: 68
          }}
        />
      </Entity>
      <div className="ccm-campaigns-table-campaign-cell__info">
        <Link
          to={route}
          title={campaignName}
          className="ccm-campaigns-table-campaign-cell__link"
        >
          {campaignName}
        </Link>
        <div className="ccm-campaigns-table-campaign-cell__meta">
          <div>
            {__t(`${MSG_KEY}.campaign_starts`)}:
          </div>
          <div>
            {getDisplayDate(campaign.startDate)}
          </div>
        </div>
        <div className="ccm-campaigns-table-campaign-cell__meta">
          <div>
            {__t(`${MSG_KEY}.outfits_go_live`)}:
          </div>
          <div>
            {getDisplayDate(campaign.timeline?.taskContentGoLiveDate)} - {getDisplayDate(campaign.timeline?.taskContentGoLiveEndDate)}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ account }): StateProps => ({
  roles: account.roles
});

export default connect(mapStateToProps)(CcmCampaignsTableCampaignCell);
